import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import * as c from '../../constants'
import { BUTTON_OFF, BUTTON_ON } from '../../../../../constants'
import DisabledPeopleIcon from '../../icons/DisabledPeople'
import PetsAllowedIcon from '../../icons/PetsAllowed'
import ParkingIcon from '../../icons/Parking'
import PoolIcon from '../../icons/Pool'
import SportIcon from '../../icons/SportsHall'
import MeetingRoomIcon from '../../icons/MeetingRoom'
import AirConditionerIcon from '../../icons/AirConditioner'
import { pushDataLayerSimple } from '../../../../../../../helpers/gtm'


class IconField extends PureComponent {
  iconState = {
    active: {},
  }

  componentWillMount() {
    this.initIconValue()
  }

  componentWillReceiveProps = (next) => {
    const nextValue = next.value
    if (this.props.value !== nextValue) {
      this.initIconValue(nextValue)
    }
  }

  initIconValue = (valueParam) => {
    const { iconId } = this.props
    let value = valueParam
    if (value === undefined) {
      value = this.props.value
    }
    this.iconState.active[iconId] = value === BUTTON_ON
  }

  onIconClick = (id) => (
    e => {
      e.stopPropagation()
      const newValue = !this.iconState.active[id]
      const { input: { onChange } } = this.props
      this.eventDataPush(id)

      this.iconState.active[id] = newValue
      return onChange(newValue ? BUTTON_ON : BUTTON_OFF, c.amenityFieldName(id))
    }
  )

  eventDataPush = (iconId) => {
    const { eventTrackingData } = this.props
    switch (iconId) {
      case c.ICON_DISABLED_PEOPLE:
        pushDataLayerSimple(eventTrackingData.disabledPeople)
        break
      case c.ICON_PETS_ALLOWED:
        pushDataLayerSimple(eventTrackingData.petsAllowed)
        break
      case c.ICON_POOL:
        pushDataLayerSimple(eventTrackingData.pool)
        break
      case c.ICON_PARKING:
        pushDataLayerSimple(eventTrackingData.parking)
        break
      case c.ICON_SPORTS_HALL:
        pushDataLayerSimple(eventTrackingData.sportsHall)
        break
      case c.ICON_MEETING_ROOM:
        pushDataLayerSimple(eventTrackingData.meetingRoom)
        break
      case c.ICON_AIR_CONDITIONER:
        pushDataLayerSimple(eventTrackingData.airConditioner)
        break
    }
  }

  isActive = id => this.iconState.active[id]

  activeClass = id => this.isActive(id) && 'active'

  iconClassName = id => cn('more-filters-icon-field__icon', this.activeClass(id))

  getIcon = (id) => {
    const { titles } = this.props
    const iconClassName = this.iconClassName(id)
    let Icon
    let label

    switch (id) {
      case c.ICON_DISABLED_PEOPLE:
        Icon = <DisabledPeopleIcon className={iconClassName} />
        label = titles.disabledPeople
        break
      case c.ICON_PETS_ALLOWED:
        Icon = <PetsAllowedIcon className={iconClassName} />
        label = titles.petsAllowed
        break
      case c.ICON_PARKING:
        Icon = <ParkingIcon className={iconClassName} />
        label = titles.parking
        break
      case c.ICON_POOL:
        Icon = <PoolIcon className={iconClassName} />
        label = titles.pool
        break
      case c.ICON_SPORTS_HALL:
        Icon = <SportIcon className={iconClassName} />
        label = titles.sportsHall
        break
      case c.ICON_MEETING_ROOM:
        Icon = <MeetingRoomIcon className={iconClassName} />
        label = titles.meetingRoom
        break
      case c.ICON_AIR_CONDITIONER:
        Icon = <AirConditionerIcon className={iconClassName} />
        label = titles.airConditioner
        break
      default:
        Icon = <div>?</div>
        label = 'Undefined Icon'
    }

    return (
      <React.Fragment>
        {Icon}
        <div className={cn('more-filters-icon-field__label', this.activeClass(id))}>
          {label}
        </div>
      </React.Fragment>
    )
  }

  render() {
    const { iconId, additionalClass } = this.props
    return (
      <button
        type="button"
        className={cn('more-filters-icon-field', additionalClass, this.activeClass(iconId))}
        onClick={this.onIconClick(iconId)}
      >
        {this.getIcon(iconId)}
      </button>
    )
  }
}


IconField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  iconId: PropTypes.string.isRequired,
  additionalClass: PropTypes.string,
  titles: PropTypes.shape({
    disabledPeople: PropTypes.string,
    petsAllowed: PropTypes.string,
    parking: PropTypes.string,
    pool: PropTypes.string,
    sportsHall: PropTypes.string,
    meetingRoom: PropTypes.string,
  }),
  eventTrackingData: PropTypes.arrayOf(String),
}

export default IconField
